export default __webpack_public_path__ + "static/media/myAccount.9f82abce.svg";